import { JSX, useMemo } from 'react'

import { NotificationPageLayout } from 'core-components/sitebuilder/common/NotificationPageLayout'

interface INoAccessPage {
  footerContent?: () => JSX.Element
}

export const NoAccessPage = ({ footerContent }: INoAccessPage) => {
  const description = useMemo(() => {
    return (
      <>
        You do not have access to the current page or its parent page.
        <br /> If you need access, ask your manager to grant it.
      </>
    )
  }, [])

  return (
    <NotificationPageLayout
      documentTitle={`404`}
      headerText={'Whoopsie!'}
      headerDescriptionText={`No access`}
      description={description}
      footerContent={footerContent}
      imageLink={
        'https://res.cloudinary.com/appbuilder/image/upload/v1685524106/Images/page_not_found.png'
      }
    />
  )
}
